import { useAuth } from "../../context/AuthContext";
import { useMenuPrefs } from "../../context/MenuPrefsContext";
import { useAccessRights } from "../../context/AccessRightsContext";
import { menuForUser, menuLayoutOf } from "../../config/navConfig";
import { useMenuPathname } from "./menuLocation";
import TopSubmenu from "./TopSubmenu";

/** Верхняя строка разделов в шапке страницы (правка №52): берёт личное меню пользователя. [Claude] 2026-11-03 */
export default function HeaderSubmenu() {
    const auth = useAuth() || {};
    const { prefs } = useMenuPrefs();
    useAccessRights(); // правка №58: перерисовать, когда загрузятся права
    const pathname = useMenuPathname();
    const layout = menuLayoutOf(prefs);
    if (layout !== "top") return <div className="flex-1 min-w-0" />;
    return <TopSubmenu items={menuForUser(auth.user?.role, prefs)} layout={layout} pathname={pathname} />;
}
